module.exports = __webpack_public_path__ + "static/media/xinghai03.fae2ade0.jpg";